import { therapyPlanningAction } from '../../actions/constant';

const {
  CREATE_ASSESSMENT_SUCCESS,
  CREATE_ASSESSMENT_FAILURE,
  RESET_CREATE_ASSESSMENT,
  CREATE_ASSESSMENT_LOADING,
} = therapyPlanningAction;

const intitialstate: object = {
  isAssessmentCreated: false,
  response: null,
  loading: false,
};

export const createAssessmentReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case CREATE_ASSESSMENT_SUCCESS: {
      return {
        ...state,
        isAssessmentCreated: true,
        response: action.payload,
        loading: false,
      };
    }

    case CREATE_ASSESSMENT_FAILURE:
      return {
        ...state,
        isAssessmentCreated: false,
        response: action.payload,
        loading: false,
      };
    case CREATE_ASSESSMENT_LOADING:
      return {
        ...state,
        loading: true,
      };
    case RESET_CREATE_ASSESSMENT:
      return intitialstate;

    default:
      return state;
  }
};
